import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikeOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		d: "M8 3.715c4.222-4.293 11.46 3.68 0 10.118C-3.46 7.394 3.778-.578 8 3.715Z"
	})
});
export default SvgLikeOutlined;
